
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStkAdjCodeDialog extends Serenity.EntityDialog<IcStkAdjCodeRow, any> {
        protected getFormKey() { return IcStkAdjCodeForm.formKey; }
        protected getIdProperty() { return IcStkAdjCodeRow.idProperty; }
        protected getLocalTextPrefix() { return IcStkAdjCodeRow.localTextPrefix; }
        protected getNameProperty() { return IcStkAdjCodeRow.nameProperty; }
        protected getService() { return IcStkAdjCodeService.baseUrl; }
        protected getDeletePermission() { return IcStkAdjCodeRow.deletePermission; }
        protected getInsertPermission() { return IcStkAdjCodeRow.insertPermission; }
        protected getUpdatePermission() { return IcStkAdjCodeRow.updatePermission; }

        protected form = new IcStkAdjCodeForm(this.idPrefix);
        // protected getToolbarButtons(): Serenity.ToolButton[] {
        //     let buttons = super.getToolbarButtons();

        //     buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
        //     buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
        //     buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
        //     return buttons;
        // }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.deleteButton.hide();
            if(this.isNew()){
                this.applyChangesButton.hide();

            }else{
                Serenity.EditorUtils.setReadOnly(this.form.StkAdjType, true);
                Serenity.EditorUtils.setReadOnly(this.form.StkAdjCode, true);
            this.saveAndCloseButton.hide();
            // this.applyChangesButton.hide();
            }
            
            var stkcode = this.form.StkAdjCode.value
            if (stkcode == '13' || stkcode == '19'|| stkcode == '16'||stkcode == '23' || stkcode == '29'|| stkcode == '26'|| stkcode == '14'|| stkcode == '24'|| stkcode == '17') {
                this.applyChangesButton.toggleClass('disabled', true);
                Serenity.EditorUtils.setReadOnly(this.form.StkAdjDesc, true);

            }

            

        }
    }
}